module.exports = __webpack_public_path__ + "static/media/credit12.a0592a09.png";